// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Player Normal */
.video-player-normal {
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.video-element {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.mini-player-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

/* Mini Player Flutuante */
.mini-player-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 300px;
  background: #1a1a1a;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  overflow: hidden;
}

.mini-player-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  background: #2a2a2a;
  color: white;
  font-size: 12px;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mini-video-element {
  width: 100%;
  height: 170px;
  object-fit: cover;
}

.mini-player-controls {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 8px;
  background: #2a2a2a;
}

.mini-player-controls button {
  background: #444;
  border: none;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.mini-player-controls button:hover {
  background: #555;
}

/* Responsivo */
@media (max-width: 768px) {
  .mini-player-container {
    width: 250px;
    bottom: 10px;
    right: 10px;
  }
  
  .mini-video-element {
    height: 140px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/infoPage/VideoMiniPlayer.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Player Normal */\n.video-player-normal {\n  position: relative;\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.video-element {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.mini-player-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n/* Mini Player Flutuante */\n.mini-player-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 300px;\n  background: #1a1a1a;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.mini-player-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 12px;\n  background: #2a2a2a;\n  color: white;\n  font-size: 12px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mini-video-element {\n  width: 100%;\n  height: 170px;\n  object-fit: cover;\n}\n\n.mini-player-controls {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  padding: 8px;\n  background: #2a2a2a;\n}\n\n.mini-player-controls button {\n  background: #444;\n  border: none;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.mini-player-controls button:hover {\n  background: #555;\n}\n\n/* Responsivo */\n@media (max-width: 768px) {\n  .mini-player-container {\n    width: 250px;\n    bottom: 10px;\n    right: 10px;\n  }\n  \n  .mini-video-element {\n    height: 140px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
